import React from "react";

interface Props {
    children: any
    flexDirection: 'row' | 'column' | undefined,
    justifyContent: 'center' | 'flex-end' | 'flex-start' | undefined
    mt: string | undefined,
    mb: string | undefined,
    alignItems: 'center' | 'flex-start' | 'flex-end' | undefined,
    ml: string | undefined,
    flexGrow: 1 | undefined,
    mr: string | undefined,
    flex: number | string | undefined,
    width: string | undefined,
    alignSelf: 'center' | 'flex-start' | 'flex-end' | undefined
    bg: string | undefined,
    height: string | undefined,
    backgroundImage: string | undefined,
    backgroundSize: 'cover' | undefined,
    pl: string | undefined,
    pr: string | undefined,
    pt: string | undefined,
    pb: string | undefined,
    onClick: any | undefined,
    actionIcon: boolean,
    onMouseOver: any | undefined
    onMouseLeave: any | undefined,
    className: string | undefined,
    borderTop: string | undefined,
    zIndex: number | undefined,
    borderRadius: string | undefined,
    boxShadow: string | undefined,
    borderBottom: string | undefined,
    borderLeft: string | undefined,
    borderRight: string | undefined,
    maxHeight: string | undefined
    minHeight: string | undefined
    maxWidth: string | undefined
    overflowY: 'scroll' | 'auto' | undefined,
    position: 'absolute' | 'relative' | 'fixed' | undefined,
    overflow: 'hidden' | undefined,
    p: string | undefined
    m: string | undefined
    border: string | undefined
    minWidth: string | number | undefined
    right: string | undefined
    _ref: any | undefined
    opacity: string | undefined
    pointerEvents: 'none' | undefined
    title: string | undefined
    gap: string | undefined
    textWrap: 'noWrap' | undefined
    flexWrap: 'wrap' | undefined,
    aspectRatio: number | undefined
    id: string | undefined
    textAlign?: 'center',
    top: string | undefined
}

const Box = ({ top, textAlign, id, aspectRatio, flexWrap, minHeight, textWrap, gap, title, maxWidth, pointerEvents, opacity, _ref, right, minWidth, border, m, p, overflow, position, overflowY, maxHeight, borderBottom, borderLeft, borderRight, boxShadow, borderRadius, zIndex, borderTop, className, pt, pb, onMouseLeave, onMouseOver, actionIcon, onClick, pr, pl, backgroundSize, backgroundImage, height, bg, alignSelf, width, flex, children, flexDirection, justifyContent, mt, mb, alignItems, ml, flexGrow, mr }: Props) => {
    return (
        <div
            id={id}
            title={title}
            ref={_ref ? _ref : undefined}
            onMouseLeave={onMouseLeave}
            onMouseOver={onMouseOver}
            className={(className ? className : '') + (actionIcon ? " actionIcon" : "")}
            onClick={onClick}
            style={
                Object.assign(
                    { display: 'flex' },
                    top ? { top: top } : {},
                    textAlign ? { textAlign: textAlign } : {},
                    aspectRatio ? { aspectRatio: aspectRatio } : {},
                    flexDirection ? { flexDirection: flexDirection } : {},
                    minHeight ? { minHeight: minHeight } : {},
                    textWrap ? { textWrap: textWrap } : {},
                    gap ? { gap: gap } : {},
                    opacity ? { opacity: opacity } : {},
                    pointerEvents ? { pointerEvents: pointerEvents } : {},
                    justifyContent ? { justifyContent: justifyContent } : {},
                    mt ? { marginTop: mt } : {},
                    mb ? { marginBottom: mb } : {},
                    ml ? { marginLeft: ml } : {},
                    mr ? { marginRight: mr } : {},
                    overflow ? { overflow: overflow } : {},
                    position ? { position: position } : {},
                    overflowY ? { overflowY: overflowY } : {},
                    maxHeight ? { maxHeight: maxHeight } : {},
                    maxWidth ? { maxWidth: maxWidth } : {},
                    borderBottom ? { borderBottom: borderBottom } : {},
                    borderLeft ? { borderLeft: borderLeft } : {},
                    borderRight ? { borderRight: borderRight } : {},
                    boxShadow ? { boxShadow: boxShadow } : {},
                    borderRadius ? { borderRadius: borderRadius } : {},
                    zIndex ? { zIndex: zIndex } : {},
                    borderTop ? { borderTop: borderTop } : {},
                    pt ? { paddingTop: pt } : {},
                    pb ? { paddingBottom: pb } : {},
                    pr ? { paddingRight: pr } : {},
                    pl ? { paddingLeft: pl } : {},
                    backgroundSize ? { backgroundSize: backgroundSize } : {},
                    backgroundImage ? { backgroundImage: backgroundImage } : {},
                    height ? { height: height } : {},
                    bg ? { backgroundColor: bg } : {},
                    alignSelf ? { alignSelf: alignSelf } : {},
                    width ? { width: width } : {},
                    flex ? { flex: flex } : {},
                    alignItems ? { alignItems: alignItems } : {},
                    flexGrow ? { flexGrow: flexGrow } : {},
                    p ? { padding: p } : {},
                    m ? { margin: m } : {},
                    border ? { border: border } : {},
                    minWidth ? { minWidth: minWidth } : {},
                    right ? { right: right } : {},
                    flexWrap ? { flexWrap: flexWrap } : {},
                )
            } >
            {children}
        </div >
    )
}

Box.defaultProps = {
    top: undefined,
    flexDirection: 'column',
    justifyContent: undefined,
    mt: undefined,
    mb: undefined,
    alignItems: undefined,
    ml: undefined,
    flexGrow: undefined,
    mr: undefined,
    flex: undefined,
    width: undefined,
    alignSelf: undefined,
    bg: undefined,
    height: undefined,
    backgroundImage: undefined,
    backgroundSize: undefined,
    pr: undefined,
    pl: undefined,
    pt: undefined,
    pb: undefined,
    onClick: undefined,
    actionIcon: false,
    onMouseOver: undefined,
    onMouseLeave: undefined,
    className: undefined,
    borderTop: undefined,
    zIndex: undefined,
    borderRadius: undefined,
    boxShadow: undefined,
    borderBottom: undefined,
    borderLeft: undefined,
    borderRight: undefined,
    maxHeight: undefined,
    overflowY: undefined,
    position: undefined,
    overflow: undefined,
    p: undefined,
    m: undefined,
    border: undefined,
    minWidth: undefined,
    right: undefined,
    _ref: undefined,
    opacity: undefined,
    pointerEvents: undefined,
    maxWidth: undefined,
    title: undefined,
    gap: undefined,
    textWrap: undefined,
    minHeight: undefined,
    flexWrap: undefined,
    aspectRatio: undefined,
    id: undefined
}

export default Box;